import ModalSelectCollection from '@/components/sections/builder/settings/modal-select-collection';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import useModal from '@/hooks/useModal';
import { ICollection } from '@/types/collection';
import { ExternalLinkIcon, RefreshCcwIcon, Trash2Icon } from 'lucide-react';
import { ChevronDown } from 'lucide-react';

type CollectionSettingType = {
  value?: Partial<ICollection>;
  onChange?: (value?: Partial<ICollection>) => void;
  label?: string;
};

export default function CollectionSetting({
  value,
  onChange,
  label = 'Collection',
}: CollectionSettingType) {
  const selectCollectionModal = useModal<Partial<ICollection>>();

  if (!value) {
    return (
      <>
        <div className='mb-4 font-bold'>{label}</div>
        <Button
          type='button'
          variant='outline'
          className='flex w-full gap-x-2 bg-white'
          onClick={() => {
            selectCollectionModal.open(value);
          }}
        >
          <span>Select Collection</span>
        </Button>
        <ModalSelectCollection
          initialValues={value}
          openModal={selectCollectionModal.isShow}
          setOpenModal={(e) => !e && selectCollectionModal.setIsShow(e)}
          onSelect={(collection) => {
            onChange?.(collection);
          }}
        />
      </>
    );
  }

  return (
    <>
      <div className='mb-2'>Collection</div>
      <div className='rounded-md bg-gray-50 py-4'>
        <div className='mb-4 flex gap-x-2 border-b border-white px-4 pb-3'>
          <div>{value.collection_name}</div>
          <ExternalLinkIcon className='h-4 w-4' />
        </div>
        <div className='px-4'>
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
              <Button type='button' variant='outline' className='flex w-full gap-x-2 bg-white'>
                <span>Change</span>
                <ChevronDown className='h-4 w-4' />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className='w-full'>
              <DropdownMenuItem
                onClick={() => {
                  selectCollectionModal.open(value);
                }}
              >
                <RefreshCcwIcon className='mr-2 h-4 w-4' />
                <div>Change collection</div>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onChange?.()}>
                <Trash2Icon className='mr-2 h-4 w-4' />
                <div>Remove collection</div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <ModalSelectCollection
        initialValues={value}
        openModal={selectCollectionModal.isShow}
        setOpenModal={(e) => !e && selectCollectionModal.setIsShow(e)}
        onSelect={(collection) => {
          onChange?.(collection);
        }}
      />
    </>
  );
}
